// extracted by mini-css-extract-plugin
module.exports = {"video":"EditorVideo_video__LWemY"};